class cOptionsUserAccess {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        var self = this;
        var elSaveBtn = $('#save-user-access-options-btn');
        this.elForm = $('#edit-user-access-options-form');
        elSaveBtn.click(function (e) { return self.onSaveBtnClick(this, e); });
    }
    onSaveBtnClick(btn, e) {
        $(btn).button('loading');
        $(this.elForm).ajaxSubmit({
            url: URL_ADMIN + '/options/main/updateaccess',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    $(btn).button('reset');
                }
                else {
                    notify.error(response.errors[0]);
                    $(btn).button('reset');
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return false;
    }
}
